/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/system';

import Color from '@tool/color';
import '../scss/common.scss';
import moQuestion, {
  changeQuestion,
  changeFourteen,
  changeFourteenEdit,
} from '../store';
import {
  ActiveLinearProgress,
  BorderLinearProgress,
  DInput,
  DefaultLinearProgress,
  NextButton,
  PrevButton,
  DCheckbox,
} from '@/styled/button';
import { cloneDeep, isEmpty, round } from 'lodash';
import { submitQuestion } from '@/styled/common';
import { observer } from 'mobx-react';

const FourteenQuestion = (props: any) => {
  const { fourteenAnswer, fourteenEdit, curtime } = moQuestion;
  const [type, setType] = useState('question');
  const [twoList, setTwoList] = useState<any>([]);
  const oneList = ['高管人员', '中层及以上人员', '核心骨干', '全员', '其他'];

  const onSave = async () => {
    const arr = fourteenAnswer?.map((res: any) => {
      let items = cloneDeep(res);
      if (res === '其他') {
        items = `${res}-${fourteenEdit}`;
      }
      return items;
    });
    const result = await submitQuestion(
      '公司为哪类员工提供长期激励',
      arr,
      curtime,
    );
    const arr1: any = [];
    oneList.forEach((res: any) => {
      if (result.some((ele: any) => ele.answer === res)) {
        result.forEach((ele: any) => {
          if (res === ele.answer) {
            arr1.push(round(ele.ratio * 100, 1));
          }
        });
      } else {
        arr1.push(0);
      }
    });
    setTwoList(arr1);
    setType('answer');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="allQuestion">
      {type === 'question' ? (
        <section className="allContent">
          <h2>
            五、长期激励（<span>{'考核周期>1年）'}</span>
          </h2>
          <h3>
            5.2 公司为哪类员工提供长期激励？<span>（多选）</span>
          </h3>
          {oneList?.map((res: any) => {
            return (
              <div
                className="checkList"
                key={res}
                onClick={() => {
                  changeFourteen(res);
                }}>
                <DCheckbox
                  style={{
                    color: fourteenAnswer.includes(res) ?
                      Color.primary :
                      Color.c87,
                  }}
                  size="small"
                  checked={fourteenAnswer.includes(res)}/>
                <span className={fourteenAnswer.includes(res) ? 'active' : ''}>
                  {res}
                </span>
                {res === '其他' && (
                  <DInput
                    value={fourteenEdit}
                    onClick={(e: any) => {
                      e.stopPropagation();
                    }}
                    onChange={(e: any) => {
                      changeFourteenEdit(e.target.value);
                    }}/>
                )}
              </div>
            );
          })}
        </section>
      ) : (
        <section className="allContent">
          <h2>五、长期激励</h2>
          <h3>5.2 公司为哪类员工提供长期激励统计结果</h3>
          {oneList?.map((res: any, r: any) => {
            return (
              <section key={res} className="items">
                <section
                  className={
                    fourteenAnswer.includes(res) ? 'proActive' : 'process'
                  }>
                  <b>{res}</b>
                  <label>{`${twoList[r]}%`}</label>
                </section>
                {!fourteenAnswer.includes(res) ? (
                  <DefaultLinearProgress
                    variant="determinate"
                    value={twoList[r]}/>
                ) : (
                  <ActiveLinearProgress
                    variant="determinate"
                    value={twoList[r]}/>
                )}
              </section>
            );
          })}
        </section>
      )}
      <section className="btnGroup">
        <section className="numProgress">
          <p className="num">
            <span>14</span> / 15
          </p>
          <BorderLinearProgress variant="determinate" value={(14 / 15) * 100} />
        </section>
        <PrevButton
          onClick={() => {
            changeQuestion(13);
          }}>
          上一题
        </PrevButton>
        {type === 'question' ? (
          <PrevButton
            onClick={() => {
              changeQuestion(15);
            }}>
            跳过此题
          </PrevButton>
        ) : (
          <PrevButton
            onClick={() => {
              setType('question');
            }}>
            重新填写
          </PrevButton>
        )}
        {type === 'question' ? (
          <NextButton onClick={onSave} disabled={isEmpty(fourteenAnswer)}>
            保存查看结果
          </NextButton>
        ) : (
          <NextButton
            onClick={() => {
              changeQuestion(15);
            }}>
            下一题
          </NextButton>
        )}
      </section>
    </section>
  );
};

export default observer(FourteenQuestion);
